class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmitHandler = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
  }

  connectedCallback() {
    this.setListeners();
    this.dispatchEvent(new CustomEvent('facets:initialized', {
      bubbles: true
    }));
  }

  setListeners() {
    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('input', this.debouncedOnSubmitHandler);
    }

    const details = this.querySelectorAll("details");
    details.forEach((detail) => {
      detail.addEventListener("toggle", (event) => {
        const openDetails = this.querySelectorAll("details[open]");
        if (detail.open) {
          openDetails.forEach((el) => {
            if (el !== detail) {
              el.removeAttribute('open');
            }
          });
        }
      });
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();

    // Add availability filter if not present
    const params = new URLSearchParams(searchParams);
    if (!params.has('filter.v.m.greyson.availability')) {
      params.append('filter.v.m.greyson.availability', '1');
    }

    this.dispatchEvent(new CustomEvent('facets:filters-changed', {
      bubbles: true,
      detail: {
        urlParameters: params.toString()
      }
    }));
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const url = new URL(event.currentTarget.href);
    const searchParams = url.search.slice(1);

    this.dispatchEvent(new CustomEvent('facets:filters-changed', {
      bubbles: true,
      detail: {
        urlParameters: searchParams
      }
    }));
  }
}

customElements.define('facet-filters-form', FacetFiltersForm);
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form');
      if (form && form.onActiveFilterClick) {
        form.onActiveFilterClick(event);
      }
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class FeaturedFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.filteredTemplate = this.closest('filtered-template');
    if (!this.filteredTemplate) {
      console.error("FeaturedFilters must be used within a 'filtered-template'");
      return;
    }
    this.init();
  }

  init() {
    this.initElements();
    this.initEventListeners();
  }

  initElements() {
    this.options = Array.from(this.querySelectorAll('input[type="checkbox"]'));
    this.optionLinks = Array.from(this.querySelectorAll('label a'));
    // Find the filters form
    this.filtersForm = this.filteredTemplate.querySelector('facet-filters-form');
  }

  initEventListeners() {
    this.addEventListener("change", (event) => {
      if (event.target.matches('input[type="checkbox"]')) {
        this.handleCheckboxChange(event.target);
      }
    });
  }

  handleCheckboxChange(option) {
    const type = option.dataset.type;
    const values = option.dataset.value.split(',');
    let triggerChange = false;
    if (!this.filtersForm) {
      console.error("No filters form found");
      return;
    }
    const form = this.filtersForm.querySelector('form');
    if (!form) {
      console.error("No form element found in filters form");
      return;
    }
    values.forEach((value) => {
      const targetEl = form.querySelector(`input[name="${type}"][data-value="${value}"]`);
      if (targetEl) {
        targetEl.checked = option.checked;
        triggerChange = true;
        // Dispatch both input and change events
        targetEl.dispatchEvent(new Event('input', { bubbles: true }));
        targetEl.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    if (triggerChange) {
      // Dispatch events on the form itself
      form.dispatchEvent(new Event('input', { bubbles: true }));
      form.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
customElements.define('featured-filters', FeaturedFilters);
